import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_2 = { class: "c-form-control-checkbox gev19__contexthelp" }
const _hoisted_3 = {
  class: "c-form-control-checkbox__label",
  for: "tariffDiscountHuG",
  style: {"max-width":"92%"}
}
const _hoisted_4 = { class: "c-form-control-checkbox__label-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_Infotext = _resolveComponent("Infotext")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.hugMitglied) = $event)),
        id: "tariffDiscountHuG",
        name: "tariffDiscountHuG",
        type: "checkbox",
        value: true,
        "data-parsley-multiple": "tariffDiscountHuG",
        "data-cy": "hugMitglied",
        class: "c-form-control-checkbox__input",
        tabindex: "0",
        "aria-label": "Haus & Grund-Mitglied (10% Rabatt)",
        "aria-describedby": "tariffDiscountHuGInfo",
        role: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.piniaStore.state.tarifinformationen.hugMitglied]
      ]),
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_component_icon_sprite, {
          "icon-name": "icon-check-mark",
          "css-klassen": "c-form-control-checkbox__icon",
          "ist-klein": true
        }),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.isMakler ? "" : "Ja, ich bin ") + "Haus & Grund-Mitglied ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("strong", null, "(10% Rabatt)", -1))
        ])
      ]),
      _createElementVNode("span", {
        role: "button",
        "aria-hidden": "true",
        tabindex: "-1",
        class: "gev19__contexthelp-open",
        title: "Hilfe anzeigen",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSichtbarkeit('tariffDiscountHuG')))
      }),
      (_ctx.isMakler)
        ? (_openBlock(), _createBlock(_component_infotext, {
            key: 0,
            name: "tariffDiscountHuG",
            id: "tariffDiscountHuGInfo",
            role: "tooltip",
            text: "Wir gewähren Ihrem Versicherungsnehmer bei Policierung des Antrages 10 % Rabatt, wenn dieser Mitglied in einem Haus & Grund Verein ist. Dieser Rabatt ist nicht kombinierbar mit weiteren Rabatten."
          }))
        : (_openBlock(), _createBlock(_component_Infotext, {
            key: 1,
            name: "tariffDiscountHuG",
            id: "tariffDiscountHuGInfo",
            role: "tooltip",
            text: "Haus & Grund ist ein Eigentümerschutzbund, welcher Eigentümern\n        verschiedene Dienstleistungen und Beratung rund um das Thema\n        Eigentum bietet."
          }))
    ])
  ]))
}